<template>
  <el-dialog
    top="2vh"
    v-if="replaceBadWord.show"
    :title="'Tin nhắn gửi đi có chứa ' + replaceBadWord.items.length + ' từ khóa nhạy cảm'"
    width="500px"
    :visible.sync="replaceBadWord.show"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    append-to-body
    @close="$emit('close')">
    <div>
      <div>
        <div class="d-flex fw-bolder font-size-14 mb-3">
          <div class="w-150px">Từ cấm</div>
          <div class="flex-1">Từ thay thế</div>
          <div style="width: 60px"></div>
        </div>
        <div class="divider-custom"></div>
        <div style="max-height: 200px; overflow-y: auto">
          <div
            v-for="(item, index) in replaceBadWord.items"
            :key="index">
            <div class="d-flex font-size-14 my-2">
              <div class="w-150px">
                <div class="d-flex">
                  <div class="">{{ item.key }}</div>
                </div>
              </div>
              <div class="flex-1">
                <el-input
                  placeholder="Nội dung thay thế"
                  @input="(e) => handleInputReplace(e, item)"
                  :value="item.replace"></el-input>
              </div>
            </div>
            <div class="divider-custom"></div>
          </div>
        </div>
      </div>
      <div class="my-2">Nội dung sau chỉnh sửa</div>
      <el-input
        ref="inputText"
        resize="none"
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 5 }"
        v-model="replaceBadWord.content"
        disabled />
      <div class="d-flex justify-content-end mt-2">
        <el-button
          size="sm"
          plain
          type="danger"
          @click="$emit('close')">
          Hủy
        </el-button>
        <el-button
          size="sm"
          type="primary"
          @click="sendReplace()">
          Gửi tin nhắn
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["dataBadWord", "newMessage", "accountId"],
  data() {
    return {
      replaceBadWord: {
        show: false,
        items: [],
        content: "",
      },
    };
  },
  computed: {
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.accountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map((item) => [item[key], item])).values()];
      return unique;
    },
  },
  methods: {
    handleInputReplace(e, item) {
      item.replace = e.replace(/\s/g, "");
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr) {
          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.newMessage;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    sendReplace() {
      this.$emit("sendReplace", {
        newMessage: this.replaceBadWord.content,
        keys: this.replaceBadWord.items.map((k) => {
          return k.key;
        }),
        replace: true,
      });
      this.$emit("close");
    },
  },
  mounted() {
    this.replaceBadWord = { ...this.dataBadWord };
  },
};
</script>

<style>
</style>